import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, catchError, map, of } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      //debugger
      var userLog = sessionStorage.getItem('data');
    
      var url = state.url;
      
      if (url == "/login" || url == "") {
        if (userLog != null ) {
          this.router.navigateByUrl("/admin/eventos");
          return false;
        } else {
          return true;
        }
      } else {
        if (userLog != null  ) {
          return true;
        } else {
          this.router.navigateByUrl("/login");
          return false;
        }
      }
  }







}
